(function($) {

	var timer;
	var timerLength = 10; // how often in ms to fire
	var offsetAmount = 2; // pixel amount to move
	function scrollScreen(screen,quit) {
		if (quit!==true){
			timer=setTimeout(function(){ scrollScreen(screen,false)}, timerLength);
		}
		else{
			clearTimeout(timer);
		}

		var img = screen.find('img');
		var screenH = screen.find('.screen__main, .phone__main').outerHeight();
		var imgH = img.outerHeight();
		var dir = screen.data('dir');
		var curTop = parseInt(img.css('top'));

		if (dir == 'down') {
			img.css('top','-='+offsetAmount);
			if (imgH + curTop <= screenH) {
				screen.data('dir','up');
			}
		} else {
			img.css('top','+='+offsetAmount);
			if (curTop >= 0) {
				screen.data('dir','down');
			}
		}
	}

	$('.mockup__screen, .mockup__phone').on('mouseenter',function(){ scrollScreen($(this),false); }).on('mouseleave',function(){ scrollScreen($(this),true); });

})( jQuery );  